/**
 * Indices of the segments inside the current term, in array order. Renewal-change snapshots (segments
 * starting after the term end) are excluded. Dates are compared as ISO calendar days, so any time component is ignored.
 */
export function currentTermSegmentIndexes(policy: {
  endDate: string;
  segments: Array<{ startDate: string }>;
}): number[] {
  const endDate = String(policy.endDate).slice(0, 10);
  return policy.segments
    .map((segment, index) => (String(segment.startDate).slice(0, 10) > endDate ? -1 : index))
    .filter((i) => i >= 0);
}
